import {
	GET_SYSTEM_BACKUP,
	GET_SYSTEM_BACKUP_FAIL,
	GET_SYSTEM_BACKUP_SUCCESS,
} from '../../../constants/maintenance/systemBackup/systemBackupConstants.js';

/**
 * Reducer function for managing system backup list state.
 *
 * This reducer handles actions related to fetching system backup data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the system backup list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const systemBackupReducer = (
	state = { systemBackupList: {} },
	action,
) => {
	switch (action.type) {
		case GET_SYSTEM_BACKUP:
			return {
				loading: true,
			};
		case GET_SYSTEM_BACKUP_SUCCESS:
			return {
				loading: false,
				systemBackupList: action.payload,
			};
		case GET_SYSTEM_BACKUP_FAIL:
			return {
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};
